(() => {
  const main = document.getElementById('main');
  const script = document.currentScript;
  if (!main || !script) return;

  const placeholder = main.querySelector('.shopify-section--rich-text .prose div > p');
  if (!placeholder) return;

  document.body.classList.add('page-insegnanti-discovery');

  const language = (document.documentElement.lang || '').toLowerCase().startsWith('en') ? 'en' : 'it';
  const copy = language === 'en'
    ? {
        heading: 'Meet our teachers',
        intro: 'Find the teacher who can guide your musical journey.',
        search: 'Search', searchLabel: 'Search teachers', searchPlaceholder: 'Type a teacher name',
        scopes: {teachers: 'Teachers', courses: 'All courses', library: 'Library'},
        courseIntro: 'Browse all available courses and find the right next step for your music.',
        libraryIntro: 'Explore books, play-alongs and other resources from the Musicezer Library.',
        instrument: 'Instrument', allInstruments: 'All instruments',
        sort: 'Sort', ascending: 'A–Z', descending: 'Z–A',
        reset: 'Clear filters', resultSingular: 'teacher', resultPlural: 'teachers',
        noResults: 'No teachers match these filters. Try another search or clear the filters.',
        productSingular: 'course', productPlural: 'courses', libraryItemSingular: 'item', libraryItemPlural: 'items',
        loading: 'Loading the complete catalogue…', loadError: 'The catalogue could not be loaded. Check your connection and try again.',
        teacherDataError: 'Teacher course data could not be fully loaded. Reload the page to try again.',
        retry: 'Try again', priceFrom: 'From',
        courses: 'VIEW COURSES',
        instruments: {
          'Basso': 'Bass', 'Batteria': 'Drums', 'Canto': 'Voice', 'Chitarra': 'Guitar',
          'Chitarra Classica': 'Classical guitar', 'Produzione': 'Production',
          'Contrabbasso': 'Double bass', 'Multi strumento': 'Multiple instruments',
          'Organo Hammond': 'Hammond organ', 'Pianoforte': 'Piano', 'Sassofono': 'Saxophone'
        }
      }
    : {
        heading: 'Incontra i nostri insegnanti',
        intro: 'Scopri chi può accompagnarti nel tuo percorso musicale.',
        search: 'Cerca', searchLabel: 'Cerca insegnanti', searchPlaceholder: 'Scrivi il nome di un insegnante',
        scopes: {teachers: 'Insegnanti', courses: 'Tutti i corsi', library: 'Library'},
        courseIntro: 'Esplora tutti i corsi disponibili e trova il prossimo passo per il tuo percorso musicale.',
        libraryIntro: 'Scopri libri, play-along e altre risorse della Library Musicezer.',
        instrument: 'Strumento', allInstruments: 'Tutti gli strumenti',
        sort: 'Ordina', ascending: 'A–Z', descending: 'Z–A',
        reset: 'Azzera i filtri', resultSingular: 'insegnante', resultPlural: 'insegnanti',
        noResults: 'Nessun insegnante corrisponde ai filtri. Prova un’altra ricerca o azzera i filtri.',
        productSingular: 'corso', productPlural: 'corsi', libraryItemSingular: 'elemento', libraryItemPlural: 'elementi',
        loading: 'Caricamento del catalogo completo…', loadError: 'Impossibile caricare il catalogo. Controlla la connessione e riprova.',
        teacherDataError: 'I collegamenti ai corsi non sono stati caricati completamente. Ricarica la pagina per riprovare.',
        retry: 'Riprova', priceFrom: 'Da',
        courses: 'VEDI CORSI',
        instruments: Object.fromEntries(['Basso', 'Batteria', 'Canto', 'Chitarra', 'Chitarra Classica', 'Produzione', 'Contrabbasso', 'Multi strumento', 'Organo Hammond', 'Pianoforte', 'Sassofono'].map(value => [value, value]))
      };

  const panel = document.createElement('section');
  panel.className = 'insegnanti-discovery-panel';
  panel.setAttribute('aria-label', copy.heading);

  const intro = document.createElement('div');
  intro.className = 'insegnanti-discovery-intro';
  const description = document.createElement('p');
  description.textContent = copy.intro;
  intro.append(description);

  const controls = document.createElement('div');
  controls.className = 'insegnanti-discovery-controls';
  controls.setAttribute('role', 'group');
  controls.setAttribute('aria-label', language === 'en' ? 'Teacher directory controls' : 'Controlli elenco insegnanti');

  const searchDetails = document.createElement('details');
  searchDetails.className = 'insegnanti-discovery-disclosure';
  const searchSummary = document.createElement('summary');
  searchSummary.textContent = copy.search;
  const searchContent = document.createElement('div');
  searchContent.className = 'insegnanti-discovery-popover';
  const scopeGroup = document.createElement('div');
  scopeGroup.className = 'insegnanti-discovery-scopes';
  scopeGroup.setAttribute('role', 'group');
  scopeGroup.setAttribute('aria-label', language === 'en' ? 'Search in' : 'Cerca in');
  const scopeOptions = {};
  for (const scope of ['teachers', 'courses', 'library']) {
    const option = document.createElement('button');
    option.type = 'button';
    option.className = 'insegnanti-discovery-scope';
    option.dataset.scope = scope;
    option.textContent = copy.scopes[scope];
    option.setAttribute('aria-pressed', scope === 'teachers' ? 'true' : 'false');
    scopeGroup.append(option);
    scopeOptions[scope] = option;
  }
  const searchLabel = document.createElement('label');
  searchLabel.className = 'insegnanti-discovery-field';
  searchLabel.textContent = copy.searchLabel;
  const search = document.createElement('input');
  search.type = 'search';
  search.id = 'insegnanti-search';
  search.name = 'teacher-search';
  search.placeholder = copy.searchPlaceholder;
  search.autocomplete = 'off';
  search.setAttribute('aria-controls', 'insegnanti-teacher-results');
  searchLabel.append(search);
  searchContent.append(scopeGroup, searchLabel);
  searchDetails.append(searchSummary, searchContent);

  const instrumentDetails = document.createElement('details');
  instrumentDetails.className = 'insegnanti-discovery-disclosure';
  const instrumentSummary = document.createElement('summary');
  instrumentSummary.textContent = copy.instrument;
  instrumentSummary.setAttribute('aria-controls', 'insegnanti-instrument-options');
  const instrumentContent = document.createElement('div');
  instrumentContent.className = 'insegnanti-discovery-popover insegnanti-discovery-instruments';
  instrumentContent.id = 'insegnanti-instrument-options';
  instrumentDetails.append(instrumentSummary, instrumentContent);

  const sortDetails = document.createElement('details');
  sortDetails.className = 'insegnanti-discovery-disclosure insegnanti-discovery-sort';
  const sortSummary = document.createElement('summary');
  sortSummary.textContent = copy.sort;
  sortSummary.setAttribute('aria-controls', 'insegnanti-sort-options');
  const sortContent = document.createElement('div');
  sortContent.className = 'insegnanti-discovery-popover insegnanti-discovery-sort-options';
  sortContent.id = 'insegnanti-sort-options';
  sortContent.setAttribute('role', 'group');
  sortContent.setAttribute('aria-label', copy.sort);
  const sortOptions = [];
  for (const [value, label] of [['asc', copy.ascending], ['desc', copy.descending]]) {
    const optionLabel = document.createElement('label');
    optionLabel.className = 'insegnanti-discovery-sort-option';
    const option = document.createElement('input');
    option.type = 'radio';
    option.name = 'insegnanti-sort';
    option.value = value;
    option.checked = value === 'asc';
    option.setAttribute('aria-controls', 'insegnanti-teacher-results');
    const optionText = document.createElement('span');
    optionText.textContent = label;
    optionLabel.append(option, optionText);
    sortContent.append(optionLabel);
    sortOptions.push(option);
  }
  sortDetails.append(sortSummary, sortContent);
  controls.append(searchDetails, instrumentDetails, sortDetails);

  const dropdowns = [searchDetails, instrumentDetails, sortDetails];
  const closeDropdowns = (except = null) => {
    for (const dropdown of dropdowns) {
      if (dropdown !== except && dropdown.open) dropdown.open = false;
    }
  };
  const positionPopover = dropdown => {
    const trigger = dropdown.querySelector(':scope > summary');
    const popover = dropdown.querySelector('.insegnanti-discovery-popover');
    if (!trigger || !popover) return;
    const triggerRect = trigger.getBoundingClientRect();
    const margin = 12;
    const viewportWidth = document.documentElement.clientWidth;
    const width = Math.min(popover.offsetWidth, viewportWidth - margin * 2);
    const left = Math.max(margin, Math.min(triggerRect.left, viewportWidth - width - margin));
    popover.style.width = `${width}px`;
    popover.style.left = `${left}px`;
    popover.style.top = `${triggerRect.bottom + 8}px`;
    popover.style.maxHeight = `${Math.max(120, window.innerHeight - triggerRect.bottom - 20)}px`;
  };

  for (const dropdown of dropdowns) {
    const trigger = dropdown.querySelector(':scope > summary');
    trigger.addEventListener('click', event => {
      event.preventDefault();
      const shouldOpen = !dropdown.open;
      closeDropdowns(dropdown);
      dropdown.open = shouldOpen;
      if (shouldOpen) positionPopover(dropdown);
    });
  }

  document.addEventListener('pointerdown', event => {
    const active = dropdowns.find(dropdown => dropdown.open);
    if (active && !active.contains(event.target)) closeDropdowns();
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = dropdowns.find(dropdown => dropdown.open);
    if (!active) return;
    event.preventDefault();
    const trigger = active.querySelector(':scope > summary');
    active.open = false;
    trigger.focus({preventScroll: true});
  });

  window.addEventListener('scroll', () => closeDropdowns(), {passive: true});
  window.addEventListener('resize', () => closeDropdowns(), {passive: true});

  const resultBar = document.createElement('div');
  resultBar.className = 'insegnanti-discovery-result-bar';
  const resultCount = document.createElement('p');
  resultCount.className = 'insegnanti-discovery-count';
  resultCount.id = 'insegnanti-discovery-count';
  resultCount.setAttribute('aria-live', 'polite');
  resultCount.setAttribute('aria-atomic', 'true');
  const reset = document.createElement('button');
  reset.type = 'button';
  reset.className = 'insegnanti-discovery-reset';
  reset.textContent = copy.reset;
  resultBar.append(resultCount, reset);

  const empty = document.createElement('p');
  empty.className = 'insegnanti-discovery-empty';
  empty.hidden = true;
  empty.textContent = copy.noResults;

  const productGrid = document.createElement('div');
  productGrid.className = 'insegnanti-discovery-product-grid';
  productGrid.id = 'insegnanti-product-results';
  productGrid.setAttribute('aria-live', 'polite');
  productGrid.hidden = true;
  const status = document.createElement('p');
  status.className = 'insegnanti-discovery-status';
  status.setAttribute('role', 'status');
  status.hidden = true;

  panel.append(intro, controls, resultBar, empty, status);
  placeholder.replaceWith(panel);
  panel.closest('.shopify-section')?.classList.add('insegnanti-discovery-section');

  const pageHeading = main.querySelector('.shopify-section--rich-text .prose h1, .shopify-section--rich-text .prose .h1');
  if (pageHeading) pageHeading.textContent = copy.heading;

  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(language).trim();
  const getProfile = href => {
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname.match(/\/pages\/([^/]+)/)?.[1] || '';
    } catch {
      return '';
    }
  };
  const cards = [...main.querySelectorAll('.multi-column__item')].filter(card =>
    card.querySelector('a[href*="/pages/"]') && card.querySelector('p.h1, p.h2, p.h3, p.h4, p.h5, p.h6')
  );
  if (!cards.length) return;

  const cardRecords = cards.map(card => {
    const title = card.querySelector('p.h1, p.h2, p.h3, p.h4, p.h5, p.h6');
    const bioLink = card.querySelector('a[href*="/pages/"]');
    return {card, title, bioLink, profile: getProfile(bioLink.href), name: title.textContent.trim(), data: null};
  });
  const directoryGrid = cards[0].closest('.multi-column');
  if (!directoryGrid) return;
  directoryGrid.id = 'insegnanti-teacher-results';
  directoryGrid.classList.add('insegnanti-directory-grid');
  const sourceSections = new Set(cards.map(card => card.closest('.shopify-section')).filter(Boolean));
  for (const record of cardRecords) directoryGrid.append(record.card);
  for (const section of sourceSections) {
    if (section !== directoryGrid.closest('.shopify-section')) section.hidden = true;
    else section.classList.add('insegnanti-directory-section');
  }
  directoryGrid.after(productGrid);

  for (const target of main.querySelectorAll('[id^="insegnanti-letter-"]')) {
    if (target.matches('.multi-column__item')) target.removeAttribute('id');
    else target.remove();
  }

  const dataInstrumentNames = {
    'Basso': 'Bass', 'Batteria': 'Drums', 'Canto': 'Voice', 'Chitarra': 'Guitar',
    'Chitarra Classica': 'Classical guitar', 'Produzione': 'Production',
    'Contrabbasso': 'Double bass', 'Multi strumento': 'Multiple instruments',
    'Organo Hammond': 'Hammond organ', 'Pianoforte': 'Piano', 'Sassofono': 'Saxophone'
  };
  const instrumentNames = language === 'en'
    ? dataInstrumentNames
    : Object.fromEntries(Object.keys(dataInstrumentNames).map(value => [value, value]));
  const checkedInstruments = () => [...instrumentContent.querySelectorAll('input:checked')].map(input => input.value);
  const updateInstrumentSummary = () => {
    const count = checkedInstruments().length;
    instrumentSummary.textContent = count ? `${copy.instrument} (${count})` : copy.instrument;
  };

  const setCourseAndInstrumentData = async () => {
    let products = [];
    let teacherDataError = false;
    try {
      products = await loadCompleteTeacherProductFeed();
    } catch (error) {
      teacherDataError = true;
      console.warn('[insegnanti-discovery] Teacher product data unavailable or incomplete; existing teacher cards remain visible.', error);
    }

    const instrumentAliases = {
      basso: 'Basso', bass: 'Basso', 'basso elettrico': 'Basso', batteria: 'Batteria', drums: 'Batteria', canto: 'Canto', voice: 'Canto',
      chitarra: 'Chitarra', guitar: 'Chitarra', 'acoustic guitar': 'Chitarra', 'chitarra acustica': 'Chitarra',
      'electric guitar': 'Chitarra', 'chitarra elettrica': 'Chitarra', 'classical guitar': 'Chitarra Classica', 'chitarra classica': 'Chitarra Classica',
      contrabbasso: 'Contrabbasso', 'multi strumento': 'Multi strumento',
      'double bass': 'Contrabbasso', 'organo hammond': 'Organo Hammond', piano: 'Pianoforte', pianoforte: 'Pianoforte',
      production: 'Produzione', produzione: 'Produzione', saxophone: 'Sassofono', sassofono: 'Sassofono'
    };
    const normalizeInstrument = value => {
      if (!value) return null;
      const key = normalize(value);
      return instrumentAliases[key] || value.trim();
    };
    const supportedInstruments = new Set(Object.keys(copy.instruments));
    const profileIdentityAliases = {enzozirillli: 'enzozirilli'};
    const identityMatches = record => {
      const displayIdentity = normalize(record.name).replace(/[^a-z0-9]/g, '');
      const profileIdentity = normalize(record.profile).replace(/[^a-z0-9]/g, '');
      return profileIdentity === displayIdentity || profileIdentityAliases[profileIdentity] === displayIdentity;
    };
    for (const record of cardRecords) {
      const content = record.card.querySelector('.prose');
      const biographyAction = record.bioLink.closest('div');
      biographyAction?.classList.add('insegnanti-card-action');
      const eligibleIdentity = identityMatches(record);
      const courses = eligibleIdentity ? products.filter(product => {
        const teacherName = normalize(record.name);
        return (normalize(product.artist || '') === teacherName && normalize(product.title || '').includes(teacherName))
          || (product.tags || []).some(tag => normalize(tag) === teacherName);
      }) : [];
      const instruments = [...new Set(courses.flatMap(course => {
        const fieldInstrument = normalizeInstrument(course.instrument);
        if (fieldInstrument && supportedInstruments.has(fieldInstrument)) return [fieldInstrument];
        return (course.tags || []).map(normalizeInstrument).filter(instrument => supportedInstruments.has(instrument));
      }))];
      record.data = eligibleIdentity ? {name: record.name, profile: record.profile, instruments, courses} : null;

      const metadata = document.createElement('div');
      metadata.className = 'insegnanti-card-discovery';
      const teacherInstruments = document.createElement('ul');
      teacherInstruments.className = 'insegnanti-card-instruments';
      teacherInstruments.setAttribute('aria-label', language === 'en' ? `Instruments taught by ${record.name}` : `Strumenti insegnati da ${record.name}`);
      for (const instrument of record.data?.instruments || []) {
        const item = document.createElement('li');
        item.textContent = instrumentNames[instrument] || instrument;
        teacherInstruments.append(item);
      }
      if (teacherInstruments.childElementCount) {
        const image = record.card.querySelector(':scope > img');
        if (image) {
          const media = document.createElement('div');
          media.className = 'insegnanti-card-media';
          image.before(media);
          media.append(image, teacherInstruments);
        } else {
          metadata.append(teacherInstruments);
        }
      }

      if (courses.length) {
        record.bioLink.textContent = copy.courses;
      } else {
        record.bioLink.remove();
        if (!biographyAction?.childElementCount) biographyAction?.remove();
      }
      if (content && metadata.childElementCount) content.append(metadata);
    }

    const availableInstruments = [...new Set(cardRecords.flatMap(record => record.data?.instruments || []).filter(value => supportedInstruments.has(value)))];
    availableInstruments.sort((a, b) => (instrumentNames[a] || a).localeCompare(instrumentNames[b] || b, language));
    for (const instrument of availableInstruments) {
      const label = document.createElement('label');
      label.className = 'insegnanti-discovery-instrument-option';
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.value = instrument;
      input.name = 'teacher-instrument';
      input.setAttribute('aria-controls', 'insegnanti-teacher-results');
      const text = document.createElement('span');
      text.textContent = instrumentNames[instrument] || instrument;
      label.append(input, text);
      instrumentContent.append(label);
    }
    instrumentDetails.hidden = availableInstruments.length === 0;
    const initialParams = new URL(window.location.href).searchParams;
    const initialInstruments = (initialParams.get('instrument') || '').split(',').filter(Boolean);
    instrumentContent.querySelectorAll('input').forEach(input => { input.checked = initialInstruments.includes(input.value); });

    let activeScope = new URL(window.location.href).searchParams.get('scope');
    if (!['teachers', 'courses', 'library'].includes(activeScope)) activeScope = 'teachers';
    const productCache = new Map();
    const productRequests = new Map();
    let currentProducts = [];

    const setHeading = scope => {
      const headings = {
        teachers: copy.heading,
        courses: copy.scopes.courses,
        library: copy.scopes.library
      };
      const introductions = {teachers: copy.intro, courses: copy.courseIntro, library: copy.libraryIntro};
      pageHeading && (pageHeading.textContent = headings[scope]);
      panel.setAttribute('aria-label', headings[scope]);
      description.textContent = introductions[scope];
      searchLabel.firstChild.textContent = scope === 'teachers'
        ? copy.searchLabel
        : (language === 'en' ? `Search ${scope === 'courses' ? 'courses' : 'the library'}` : `Cerca ${scope === 'courses' ? 'nei corsi' : 'nella Library'}`);
      search.placeholder = scope === 'teachers'
        ? copy.searchPlaceholder
        : (language === 'en' ? `Search ${scope === 'courses' ? 'courses' : 'the Library'}` : `Cerca ${scope === 'courses' ? 'un corso' : 'nella Library'}`);
      const resultId = scope === 'teachers' ? 'insegnanti-teacher-results' : 'insegnanti-product-results';
      search.setAttribute('aria-controls', resultId);
      sortOptions.forEach(option => option.setAttribute('aria-controls', resultId));
      instrumentDetails.hidden = scope !== 'teachers' || !availableInstruments.length;
      directoryGrid.hidden = scope !== 'teachers';
      productGrid.hidden = scope === 'teachers';
      for (const [key, option] of Object.entries(scopeOptions)) option.setAttribute('aria-pressed', key === scope ? 'true' : 'false');
      render();
    };

    const render = () => {
      const query = normalize(search.value);
      const selected = checkedInstruments();
      const direction = sortOptions.find(option => option.checked)?.value === 'desc' ? -1 : 1;
      const activeHeading = activeScope === 'teachers' ? copy.heading : copy.scopes[activeScope];
      panel.setAttribute('aria-label', activeHeading);
      resultBar.hidden = activeScope !== 'teachers' && !productCache.has(activeScope);
      status.hidden = activeScope === 'teachers' ? !teacherDataError : false;
      if (activeScope === 'teachers' && teacherDataError) status.textContent = copy.teacherDataError;
      empty.hidden = true;
      if (activeScope !== 'teachers') {
        if (!productCache.has(activeScope)) {
          productGrid.replaceChildren();
          resultBar.hidden = true;
          status.hidden = false;
          status.textContent = copy.loading;
          const requestedScope = activeScope;
          if (!productRequests.has(requestedScope)) {
            const request = fetchCompleteCollection(requestedScope).then(products => {
              productCache.set(requestedScope, products);
              productRequests.delete(requestedScope);
              if (activeScope === requestedScope) {
                currentProducts = products;
                render();
              }
            }).catch(error => {
              productRequests.delete(requestedScope);
              console.warn(`[insegnanti-discovery] ${requestedScope} collection could not be loaded.`, error);
              if (activeScope !== requestedScope) return;
              productGrid.replaceChildren();
              status.hidden = false;
              status.textContent = copy.loadError;
              const retry = document.createElement('button');
              retry.type = 'button';
              retry.className = 'insegnanti-discovery-retry';
              retry.textContent = copy.retry;
              retry.addEventListener('click', () => render());
              status.append(' ', retry);
            });
            productRequests.set(requestedScope, request);
          }
          return;
        }
        currentProducts = productCache.get(activeScope);
        const visibleProducts = currentProducts.filter(product => normalize(product.title || '').includes(query));
        visibleProducts.sort((a, b) => direction * (a.title || '').localeCompare(b.title || '', language, {sensitivity: 'base'}));
        productGrid.replaceChildren(...visibleProducts.map(createProductCard));
        resultBar.hidden = false;
        const productWord = activeScope === 'library'
          ? (visibleProducts.length === 1 ? copy.libraryItemSingular : copy.libraryItemPlural)
          : (visibleProducts.length === 1 ? copy.productSingular : copy.productPlural);
        resultCount.textContent = `${visibleProducts.length} ${productWord}`;
        reset.hidden = !query && !selected.length && sortOptions.find(option => option.checked)?.value !== 'desc';
        status.hidden = true;
        empty.hidden = visibleProducts.length !== 0;
        empty.textContent = language === 'en' ? 'No items match this search. Try another search or clear it.' : 'Nessun elemento corrisponde alla ricerca. Prova un’altra ricerca o azzerala.';
        return;
      }
      resultBar.hidden = false;
      status.hidden = teacherDataError;
      if (teacherDataError) status.textContent = copy.teacherDataError;
      const visible = cardRecords.filter(record => {
        const matchesName = !query || normalize(record.name).includes(query);
        const matchesInstrument = !selected.length || selected.some(instrument => record.data?.instruments?.includes(instrument));
        return matchesName && matchesInstrument;
      });
      visible.sort((a, b) => direction * a.name.localeCompare(b.name, language, {sensitivity: 'base'}));
      for (const record of cardRecords) record.card.hidden = !visible.includes(record);
      for (const record of visible) directoryGrid.append(record.card);

      resultCount.textContent = `${visible.length} ${visible.length === 1 ? copy.resultSingular : copy.resultPlural}`;
      empty.hidden = visible.length !== 0;
      empty.textContent = copy.noResults;
      reset.hidden = !query && selected.length === 0 && sortOptions.find(option => option.checked)?.value !== 'desc';
      updateInstrumentSummary();
    };

    async function loadCompleteTeacherProductFeed() {
      const readFeed = doc => {
        const feed = doc.querySelector('#insegnanti-product-feed');
        if (!feed) throw new Error('Liquid product feed is missing from the page');
        const payload = JSON.parse(feed.textContent || '{}');
        const page = Number(payload.page);
        const pages = Number(payload.pages);
        const total = Number(payload.total);
        if (!Array.isArray(payload.products) || !Number.isInteger(page) || !Number.isInteger(pages)
          || page < 1 || pages < 1 || page > pages || !Number.isInteger(total) || total < 0) {
          throw new Error('Liquid product feed metadata is invalid');
        }
        return {...payload, page, pages, total};
      };

      const first = readFeed(document);
      const all = [...first.products];
      if (first.pages > 20) throw new Error('All-products feed exceeded the 20-page safety limit');
      for (let page = 2; page <= first.pages; page += 1) {
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(page));
        const response = await fetch(url.href, {credentials: 'same-origin', headers: {Accept: 'text/html'}});
        if (!response.ok) throw new Error(`All-products page ${page} failed (${response.status})`);
        const html = await response.text();
        const next = readFeed(new DOMParser().parseFromString(html, 'text/html'));
        if (next.page !== page || next.pages !== first.pages || next.total !== first.total) {
          throw new Error(`All-products page ${page} has inconsistent pagination metadata`);
        }
        all.push(...next.products);
      }

      const ids = new Set();
      const handles = new Set();
      for (const product of all) {
        if (!product || product.id == null || !product.handle || !product.title || !product.url
          || ids.has(String(product.id)) || handles.has(product.handle) || !Array.isArray(product.tags)) {
          throw new Error('All-products feed is incomplete or contains duplicate records');
        }
        ids.add(String(product.id));
        handles.add(product.handle);
      }
      if (all.length !== first.total) throw new Error(`All-products feed returned ${all.length} of ${first.total} products`);
      return all;
    }

    const collectionHandles = {courses: 'corsi-musicezer', library: 'library'};
    const fetchCompleteCollection = async scope => {
      const root = window.Shopify?.routes?.root || (language === 'en' ? '/en/' : '/');
      const collectionUrl = new URL(`${root.replace(/^\/+|\/+$/g, '') ? `${root.replace(/^\/+|\/+$/g, '')}/` : ''}collections/${collectionHandles[scope]}/products.json`, window.location.origin);
      const all = [];
      const ids = new Set();
      for (let page = 1; page <= 20; page += 1) {
        const url = new URL(collectionUrl);
        url.searchParams.set('limit', '250');
        url.searchParams.set('page', String(page));
        const response = await fetch(url.href, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error(`Collection request failed (${response.status})`);
        const payload = await response.json();
        if (!payload || !Array.isArray(payload.products)) throw new Error('Collection response has no products array');
        for (const product of payload.products) {
          if (!product || product.id == null || !product.handle || !product.title || ids.has(product.id)) throw new Error('Collection response is incomplete or contains duplicate products');
          ids.add(product.id);
          all.push(product);
        }
        if (payload.products.length < 250) return all;
      }
      throw new Error('Collection pagination exceeded the safety limit');
    };

    const money = value => new Intl.NumberFormat(language === 'en' ? 'en-GB' : 'it-IT', {style: 'currency', currency: 'EUR'}).format(value);
    const createProductCard = product => {
      const card = document.createElement('article');
      card.className = 'insegnanti-discovery-product-card';
      const link = document.createElement('a');
      const localizedRoot = window.Shopify?.routes?.root || (language === 'en' ? '/en/' : '/');
      const root = localizedRoot.replace(/^\/+|\/+$/g, '');
      link.href = new URL(`${root ? `${root}/` : ''}products/${encodeURIComponent(product.handle)}`, window.location.origin).href;
      link.className = 'insegnanti-discovery-product-link';
      const imageUrl = product.image?.src || product.images?.[0]?.src;
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = product.image?.alt || product.title;
        image.loading = 'lazy';
        image.decoding = 'async';
        link.append(image);
      }
      const title = document.createElement('h2');
      title.textContent = product.title;
      link.append(title);
      card.append(link);
      const prices = (product.variants || []).map(variant => Number(variant.price)).filter(price => Number.isFinite(price) && price > 0);
      if (prices.length) {
        const price = document.createElement('p');
        const minimum = Math.min(...prices);
        const maximum = Math.max(...prices);
        price.className = 'insegnanti-discovery-product-price';
        price.textContent = minimum === maximum ? money(minimum) : `${copy.priceFrom} ${money(minimum)}`;
        card.append(price);
      }
      return card;
    };

    const syncUrl = (push = false) => {
      const url = new URL(window.location.href);
      if (activeScope === 'teachers') url.searchParams.delete('scope');
      else url.searchParams.set('scope', activeScope);
      if (search.value) url.searchParams.set('q', search.value);
      else url.searchParams.delete('q');
      const direction = sortOptions.find(option => option.checked)?.value || 'asc';
      if (direction === 'desc') url.searchParams.set('sort', direction);
      else url.searchParams.delete('sort');
      const selected = checkedInstruments();
      if (selected.length) url.searchParams.set('instrument', selected.join(','));
      else url.searchParams.delete('instrument');
      window.history[push ? 'pushState' : 'replaceState']({discovery: true}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    search.addEventListener('input', () => { render(); syncUrl(); });
    instrumentContent.addEventListener('change', () => { render(); syncUrl(); });
    sortContent.addEventListener('change', () => {
      render();
      syncUrl();
      sortDetails.open = false;
      sortSummary.focus({preventScroll: true});
    });

    for (const [scope, option] of Object.entries(scopeOptions)) {
      option.addEventListener('click', () => {
        if (activeScope === scope) return;
        closeDropdowns();
        activeScope = scope;
        syncUrl(true);
        setHeading(scope);
          searchSummary.focus({preventScroll: true});
      });
    }

    reset.addEventListener('click', () => {
      search.value = '';
      for (const checkbox of instrumentContent.querySelectorAll('input')) checkbox.checked = false;
      sortOptions.forEach(option => { option.checked = option.value === 'asc'; });
      render();
      syncUrl();
      closeDropdowns(searchDetails);
      searchDetails.open = true;
      search.focus();
    });

    window.addEventListener('popstate', () => {
      const url = new URL(window.location.href);
      activeScope = ['teachers', 'courses', 'library'].includes(url.searchParams.get('scope')) ? url.searchParams.get('scope') : 'teachers';
      search.value = url.searchParams.get('q') || '';
      const direction = url.searchParams.get('sort') === 'desc' ? 'desc' : 'asc';
      sortOptions.forEach(option => { option.checked = option.value === direction; });
      const selected = (url.searchParams.get('instrument') || '').split(',').filter(Boolean);
      instrumentContent.querySelectorAll('input').forEach(input => { input.checked = selected.includes(input.value); });
      if (productCache.has(activeScope)) currentProducts = productCache.get(activeScope);
      setHeading(activeScope);
    });
    search.value = new URL(window.location.href).searchParams.get('q') || '';
    if (new URL(window.location.href).searchParams.get('sort') === 'desc') sortOptions.find(option => option.value === 'desc').checked = true;
    syncUrl();
    setHeading(activeScope);
  };

  setCourseAndInstrumentData();
})();
